import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ValidationTypes } from '../../../shared/model/api/ValidatorTypes';
import { ViewConstants } from '../../../constants';
import { DDCurrencyPricePipe } from '../pipes/currency-price.pipe';

/**
 * Class used to validate the user entered inputs
 */
@Directive({
    selector: '[ddFieldValidator]',
    standalone: false
})
export class DDFieldValidatorDirective {
    // Input REGEX type to be used
    @Input() ddFieldValidator: ValidationTypes;
    // Input REGEX type to be used
    @Input() isTrimTrailingSpaces: boolean = false;
    // REGEX for Numeric 7 Validator Type
    private readonly NUMBER_7_REGEX: string = '^\\d{0,5}(\\.\\d{0,2})?$';
    // REGEX for Numeric 7 Validator Type
    private readonly NUMBER_40_REGEX: string = '^\\d{0,20}(\\.\\d{0,20})?$';
    // REGEX for Numeric 4 Validator Type
    private readonly NUMBER_4_REGEX: string = '^\\d{0,2}(\\.\\d{0,2})?$';
    // REGEX for Numeric 7 with Plus and Minus sign Validator Type
    private readonly NUMBER_7_PLUSMINUS_REGEX: string = '^[+-]?\\d{0,5}(\\.\\d{0,2})?$';
    // REGEX for Numeric 7 with $
    private readonly NUMBER_7_WITHDOLLAR_REGEX: string = '^\\$?\\d{0,5}(\\.\\d{0,2})?$';
    // REGEX for Numeric 9 with $
    private readonly NUMBER_9_WITHDOLLAR_REGEX: string = '^\\$?\\d{0,7}(\\.\\d{0,2})?$';
   
    // REGEX for Numeric 4 with Plus and Minus sign Validator Type
    private readonly NUMBER_4_PLUSMINUS_REGEX: string = '^[+-]?\\d{0,2}(\\.\\d{0,2})?$';
    // REGEX for AlphaNumeric 3000 Validator Type
    private readonly ALPHANUMERIC_3000_REGEX: string = '^[\\w\\W\\s]{0,3000}$';
    // REGEX for AlphaNumeric 500 Validator Type
    private readonly ALPHANUMERIC_500_REGEX: string = '^[\\w\\W\\s]{0,500}$';
    // REGEX for AlphaNumeric 35 Validator Type
    private readonly ALPHANUMERIC_35_REGEX: string = '^[\\w\\W\\s]{0,35}$';
    // REGEX for AlphaNumeric 20 Validator Type
    private readonly ALPHANUMERIC_20_REGEX: string = '^[\\w\\W\\s]{0,20}$';
    // REGEX for AlphaNumeric 14 Validator Type
    private readonly ALPHANUMERIC_14_REGEX: string = '^[\\w\\d\\-]{0,14}$';
    // REGEX for AlphaNumeric 10 Validator Type
    private readonly ALPHANUMERIC_10_REGEX: string = '^[\\w\\d\\-]{0,10}$';
    // REGEX for AlphaNumeric 50 Validator Type
    private readonly ALPHANUMERIC_50_REGEX: string = '^[\\w\\d\\-]{0,50}$';
    // REGEX for AlphaNumeric 24 Validator Type
    private readonly ALPHANUMERIC_24_REGEX: string = '^[\\w\\d\\s-]{0,24}$';
    // REGEX for AlphaNumeric Validator Type
    private readonly ALPHANUMERIC_REGEX: string = '^[a-zA-Z0-9\\s]*$';
    // REGEX for Numeric 7 with LESS and GREATER sign Validator Type
    private readonly NUMBER_7_LESSGREATER_REGEX: string = '^[<>]?[NA]{0,2}?\\d{0,5}(\\.\\d{0,2})?$';
    // REGEX for Numeric 5 with LESS and GREATER sign Validator Type
    private readonly NUMBERONLY_5_LESSGREATER_REGEX: string = '^[<>]?[NA]{0,2}?\\d{0,5}?$';

    // REGEX for AlphaNumeric 4 without space Validator Type
    private readonly ALPHANUMERIC_4_WITHOUTSPACE_REGEX: string = '^[a-zA-Z0-9]{0,4}$';

    // REGEX for Numeric 3 Validator Type
    private readonly NUMBERONLY_2_REGEX: string = '^\\d{0,2}?$';
    // REGEX for Numeric 3 Validator Type
    private readonly NUMBERONLY_3_REGEX: string = '^\\d{0,3}?$';

    // REGEX for Numeric 4 Validator Type
    private readonly NUMBERONLY_4_REGEX: string = '^\\d{0,4}?$';

    // REGEX for Numeric 5 Validator Type
    private readonly NUMBERONLY_5_REGEX: string = '^\\d{0,5}?$';

    // REGEX for Numeric 7 Validator Type
    private readonly NUMBERONLY_7_REGEX: string = '^\\d{0,7}?$';


    // REGEX for AlphaNumeric  without space Validator Type
    private readonly ALPHANUMERIC_WITHOUTSPACE_REGEX: string = '^[a-zA-Z0-9]*$';

    // REGEX for AlphaNumeric 5 without space Validator Type
    private readonly ALPHANUMERIC_5_WITHOUTSPACE_REGEX: string = '^[a-zA-Z0-9]{0,5}$';

    // REGEX for AlphaNumeric 3 without space Validator Type
    private readonly ALPHANUMERIC_3_WITHOUTSPACE_REGEX: string = '^[a-zA-Z0-9]{0,3}$';

    // REGEX for Alphabet 1 Validator Type
    private readonly ALPHABET_1_REGEX: string = '^[a-zA-Z]{0,1}$';
    // REGEX for Alphabet 2 Validator Type
    private readonly ALPHABET_2_REGEX: string = '^[a-zA-Z*]{0,2}$';
    // REGEX for AlphaNumeric 5 without space Validator Type
    private readonly ALPHANUMERIC_17_WITHOUTSPACE_REGEX: string = '^[a-zA-Z0-9]{0,17}$';

    // REGEX for AlphaNumeric along with special characters 10 Validator Type
    private readonly ALPHANUMERIC_SPECIAL_10_REGEX: string = '^.{0,10}$';

    // REGEX for AlphaNumeric along with special characters 14 Validator Type
    private readonly ALPHANUMERIC_SPECIAL_14_REGEX: string = '^.{0,14}$';

    // REGEX for AlphaNumeric along with special characters 30 Validator Type
    private readonly ALPHANUMERIC_SPECIAL_30_REGEX: string = '^.{0,30}$';

    // REGEX for AlphaNumeric along with special characters and no white space 14 Validator Type
    private readonly ALPHANUMERIC_SPECIAL_14_WITHOUTSPACE_REGEX: string = '^[a-zA-Z0-9\\-]{0,14}$';

    // Lower Limit 0.0000
    // Uppper Limit 1.0000
    // REGEX for Numeric 10 Validator Type
    private readonly NUMBER_10_REGEX: string = '^(0?(\\.\\d{0,5})?|1(\\.0{0,5})?)$';

    private readonly POSITIVE_INTEGER_REGEX = '^[0-9]{0,10}(\\.[0-9]{0,5})?$';

    // REGEX for Numeric values Validator Type
    private readonly NUMBER_REGEX: string = '^[0-9]{0,10}(\\.[0-9]{0,2})?$';
    private readonly NUMBER_REGEX_ZIP: string = '^\\d{0,5}?$'
    private readonly NUMBER_6_REGEX: string = '^\\d{0,6}?$';
    // REGEX for Integer values along with minus Validator Type
    private readonly INTEGER_REGEX: string = '^[-]?\\d*$';

    // REGEX for 14 Characters
    private readonly CHAR_14_REGEX: string = '^[A-Za-z]{0,14}$';

    // REGEX for Characters
    private readonly CHAR_REGEX: string = '\\w';


    // Constructor for Field Validator Directive
    constructor(private readonly el: ElementRef) { }

    // Host Listener for Key Down event
    @HostListener('keydown', ['$event']) onKeyDown(event) {
        let value = event.target.value;
        const e = <KeyboardEvent>event;

        if (this.isTrimTrailingSpaces === true
            && value !== null && value !== undefined) {
            value = value.trim();
        }

        if ([9, 27, 13, 16, 20].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && e.ctrlKey === true) ||
            // Allow: Ctrl+v
            (e.keyCode === 86 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }


        let startPos: number = event.srcElement.selectionStart;
        let endPos: number = event.srcElement.selectionEnd;
        let appendValue: string = e.key;

        // To validate the final number for backspace and delete
        if (e.keyCode === 8) {
            startPos = startPos - 1;
            appendValue = '';
        } else if (e.keyCode === 46) {
            endPos = endPos + 1;
            appendValue = '';
        }

        if (value.length === startPos) {
            value += appendValue;
        } else {
            let tempValue = '';
            tempValue = value.substring(0, startPos) + appendValue;
            if (value.length > endPos) {
                tempValue += value.substring(endPos);
            }
            value = tempValue;
        }



        if (!this.isValidEntry(value, 'KEYDOWN', appendValue)) {
            e.preventDefault();
        }
    }

    // Host Listener for Paste event
    @HostListener('paste', ['$event']) onPaste(event) {
        const e = <KeyboardEvent>event;
        let pastedText = event.clipboardData.getData('text/plain');
        let value: string = event.srcElement.value;
        const startPos: number = event.srcElement.selectionStart;
        const endPos: number = event.srcElement.selectionEnd;
        if (this.isTrimTrailingSpaces === true) {
            pastedText = pastedText.trim();
        }
        if (value.length === startPos && startPos === endPos) {
            value += pastedText;
        } else if (startPos === 0 && startPos === endPos) {
            value = pastedText + value;
        } else {
            let tempValue = '';
            tempValue = value.substring(0, startPos) + pastedText;
            if (value.length > endPos) {
                tempValue += value.substring(endPos);
            }
            value = tempValue;
        }
        if (this.ddFieldValidator === ValidationTypes.NUMBER_7_WITHDOLLARANDCOMMA) {
            const tempValue = value.replace(ViewConstants.COMMA, ViewConstants.EMPTY_STRING).
                replace(ViewConstants.USD_SYMBOL, ViewConstants.EMPTY_STRING);
            const regEx = new RegExp(this.NUMBER_7_REGEX);
            if (regEx.test(tempValue)) {
                e.preventDefault();
                event.target.value = tempValue;
            } else {
                e.preventDefault();
            }
        } else if (!this.isValidEntry(value, 'PASTE')) {
            e.preventDefault();
        }
    }

    // Validate the user input against the REGEX pattern
    public isValidEntry(value: any, operation: string, actualKey = ''): boolean {
        let isValid = true;
        let regEx: RegExp = null;
        let removeComma = false;
        if (this.ddFieldValidator === ValidationTypes.NUMBER_7) {
            regEx = new RegExp(this.NUMBER_7_REGEX);
            removeComma = true;
        }else if (this.ddFieldValidator === ValidationTypes.NUMBER_40) {
            regEx = new RegExp(this.NUMBER_40_REGEX);
            removeComma = true;
        } else if (this.ddFieldValidator === ValidationTypes.NUMBER_4) {
            regEx = new RegExp(this.NUMBER_4_REGEX);
            removeComma = true;
        }else if (this.ddFieldValidator === ValidationTypes.NUMBER_7_WITHPLUSMINUS) {
            regEx = new RegExp(this.NUMBER_7_PLUSMINUS_REGEX);
            removeComma = true;
        } else if (this.ddFieldValidator === ValidationTypes.NUMBER_7_WITHDOLLAR) {
            regEx = new RegExp(this.NUMBER_7_WITHDOLLAR_REGEX);
            removeComma = true;
        } else if (this.ddFieldValidator === ValidationTypes.NUMBER_9_WITHDOLLAR) {
            regEx = new RegExp(this.NUMBER_9_WITHDOLLAR_REGEX);
            removeComma = true;
        }  else if (this.ddFieldValidator === ValidationTypes.NUMBER_4_WITHPLUSMINUS) {
            regEx = new RegExp(this.NUMBER_4_PLUSMINUS_REGEX);
            removeComma = true;
        }
        else if (this.ddFieldValidator === ValidationTypes.NUMBERONLY_2) {
            regEx = new RegExp(this.NUMBERONLY_2_REGEX);
            removeComma = true;
        }
        else if (this.ddFieldValidator === ValidationTypes.NUMBERONLY_3) {
            regEx = new RegExp(this.NUMBERONLY_3_REGEX);
            removeComma = true;
        } else if (this.ddFieldValidator === ValidationTypes.NUMBERONLY_4) {
            regEx = new RegExp(this.NUMBERONLY_4_REGEX);
            removeComma = true;
        } else if (this.ddFieldValidator === ValidationTypes.NUMBERONLY_5) {
            regEx = new RegExp(this.NUMBERONLY_5_REGEX);
            removeComma = true;
        } else if (this.ddFieldValidator === ValidationTypes.NUMBERONLY_ZIP) {
            regEx = new RegExp(this.NUMBER_REGEX_ZIP);
            removeComma = true;
        }else if (this.ddFieldValidator === ValidationTypes.NUMBER_SP) {
            regEx = new RegExp(this.NUMBER_6_REGEX);
            removeComma = true;
        }else if (this.ddFieldValidator === ValidationTypes.NUMBERONLY_7) {
            regEx = new RegExp(this.NUMBERONLY_7_REGEX);
            removeComma = true;
        } else if (this.ddFieldValidator === ValidationTypes.NUMBER_7_LESSGREATER) {
            regEx = new RegExp(this.NUMBER_7_LESSGREATER_REGEX);
            removeComma = true;
        } else if (this.ddFieldValidator === ValidationTypes.NUMBERONLY_5_LESSGREATER) {
            regEx = new RegExp(this.NUMBERONLY_5_LESSGREATER_REGEX);
            removeComma = true;
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_3000) {
            regEx = new RegExp(this.ALPHANUMERIC_3000_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_500) {
            regEx = new RegExp(this.ALPHANUMERIC_500_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_35) {
            regEx = new RegExp(this.ALPHANUMERIC_35_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_24) {
            regEx = new RegExp(this.ALPHANUMERIC_24_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_20) {
            regEx = new RegExp(this.ALPHANUMERIC_20_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_14) {
            regEx = new RegExp(this.ALPHANUMERIC_14_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_10) {
            regEx = new RegExp(this.ALPHANUMERIC_10_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_50) {
            regEx = new RegExp(this.ALPHANUMERIC_50_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC) {
            regEx = new RegExp(this.ALPHANUMERIC_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_WITHOUTSPACE) {
            regEx = new RegExp(this.ALPHANUMERIC_WITHOUTSPACE_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_4_WITHOUTSPACE) {
            regEx = new RegExp(this.ALPHANUMERIC_4_WITHOUTSPACE_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_5_WITHOUTSPACE) {
            regEx = new RegExp(this.ALPHANUMERIC_5_WITHOUTSPACE_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_17_WITHOUTSPACE) {
            regEx = new RegExp(this.ALPHANUMERIC_17_WITHOUTSPACE_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_3_WITHOUTSPACE) {
            regEx = new RegExp(this.ALPHANUMERIC_3_WITHOUTSPACE_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHABET_1) {
            regEx = new RegExp(this.ALPHABET_1_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHABET_2) {
            regEx = new RegExp(this.ALPHABET_2_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_SPECIAL_10) {
            regEx = new RegExp(this.ALPHANUMERIC_SPECIAL_10_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_SPECIAL_14) {
            regEx = new RegExp(this.ALPHANUMERIC_SPECIAL_14_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_SPECIAL_30) {
            regEx = new RegExp(this.ALPHANUMERIC_SPECIAL_30_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.ALPHANUMERIC_SPECIAL_14_WITHOUTSPACE) {
            regEx = new RegExp(this.ALPHANUMERIC_SPECIAL_14_WITHOUTSPACE_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.NUMBER_10) {
            regEx = new RegExp(this.NUMBER_10_REGEX); 
        }else if (this.ddFieldValidator === ValidationTypes.POSITIVE_INTEGER) {
            regEx = new RegExp(this.POSITIVE_INTEGER_REGEX); 
        } else if (this.ddFieldValidator === ValidationTypes.NUMBER) {
            regEx = new RegExp(this.NUMBER_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.INTEGER) {
            regEx = new RegExp(this.INTEGER_REGEX);
        }
        else if (this.ddFieldValidator === ValidationTypes.CHAR) {
            regEx = new RegExp(this.CHAR_REGEX);
        }
        else if (this.ddFieldValidator === ValidationTypes.CHAR_14) {
            regEx = new RegExp(this.CHAR_14_REGEX);
        } else if (this.ddFieldValidator === ValidationTypes.NUMBER_7_WITHDOLLARANDCOMMA) {
            regEx = new RegExp(this.NUMBER_7_REGEX);
        }
        if (removeComma) {
            const tempValue = value.replace(new RegExp(ViewConstants.COMMA, 'g'),
                ViewConstants.EMPTY_STRING);
            if (operation === 'KEYDOWN' ||
                (operation === 'PASTE' &&
                    value === new DDCurrencyPricePipe().transform(value, false))) {
                value = tempValue;
            }
        }

        if (regEx && !regEx.test(value) || (removeComma === true && actualKey === ',')) {
            isValid = false;
        }
        return isValid;
    }
}
